var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBonusIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 120,
    viewBox: "0 0 131 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.3324,
    cy: 59.6589,
    rx: 38,
    ry: 53.5,
    transform: "rotate(-60 65.3324 59.6589)",
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.1721 51.311H76.2104V82.8851H87.1721V51.311Z",
    fill: "#E4A440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2105 51.311H47.251V82.8851H76.2105V51.311Z",
    fill: "#F2AE43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2104 68.9666V66.7566H47.2509V68.9666H76.2104Z",
    fill: "#CB8D29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1719 68.9666V66.7566H76.2102V68.9666H87.1719Z",
    fill: "#BB8124"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2178 51.6496C67.2178 51.6496 73.7604 47.3981 78.2078 48.7642L77.2902 49.621L77.7036 51.061C77.7036 51.061 72.7582 49.4506 67.0825 51.8918L67.2178 51.6496Z",
    fill: "#F2AE43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.852 50.6865C66.852 50.6865 65.6976 50.5469 63.977 50.3103C59.4095 49.6819 50.854 48.3677 49.3184 47.1513C46.9055 45.2404 52.6231 37.1254 55.0982 35.999C57.5731 34.8735 66.852 50.6865 66.852 50.6865Z",
    fill: "#F2AE43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9533 40.5812C85.3657 42.5918 66.6821 51.2771 66.6821 51.2771C66.6821 51.2771 67.0222 50.358 67.5751 48.9186C67.5751 48.9186 67.5761 48.9173 67.5767 48.9161C69.5964 43.6597 74.4628 31.4615 76.0616 31.6304C76.2224 31.6471 76.4102 31.7046 76.62 31.7965C79.076 32.8773 84.5733 38.7298 84.953 40.5812H84.9533Z",
    fill: "#F2AE43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4622 33.5841C75.3213 35.566 67.6954 48.7113 67.5762 48.9161C69.5962 43.6597 74.4626 31.4615 76.0614 31.6304C76.0614 31.6304 76.3782 31.6213 76.6198 31.7965C76.9113 32.0088 77.0922 32.4897 76.4622 33.5841Z",
    fill: "#BB8124"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9797 50.3106H63.9765C59.409 49.6821 50.8536 48.3679 49.3179 47.1516C48.6247 45.1985 50.4236 45.0394 51.733 44.9019C53.0412 44.7645 63.9797 50.3106 63.9797 50.3106Z",
    fill: "#BB8124"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3677 51.3085C63.3677 51.3085 64.4151 48.9258 66.4764 48.794C68.6294 48.6562 69.8521 51.3085 69.8521 51.3085H63.3677Z",
    fill: "#F2AE43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6751 51.311H46.373V55.6537H76.6751V51.311Z",
    fill: "#FFC261"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0965 51.311H76.6753V55.6537H88.0965V51.311Z",
    fill: "#BB8124"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4285 50.9474C64.4285 50.9474 58.4936 49.0673 54.4888 50.3104C49.8725 51.7432 50.1461 57.439 50.1461 57.439L51.232 56.9927L52.6978 57.6803C52.6978 57.6803 52.945 51.6488 56.7086 50.8043C59.9629 50.0742 64.4288 50.9471 64.4288 50.9471L64.4285 50.9474Z",
    fill: "#F2AE43"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3838 51.311H59.1738V82.8816H61.3838V51.311Z",
    fill: "#CB8D29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4214 66.8677H57.8467V82.9251H63.4214V66.8677Z",
    fill: "#4A75CB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8464 66.8677H43.1187V82.9251H57.8464V66.8677Z",
    fill: "#739AF0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8467 75.8468V74.7229H43.1189V75.8468H57.8467Z",
    fill: "#AFCDFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4214 75.8465V74.7227H57.8466V75.8465H63.4214Z",
    fill: "#88B3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8626 66.6206C53.8626 66.6206 58.3779 64.5713 61.525 65.3498L60.8965 65.7704L61.2132 66.5127C61.2132 66.5127 57.7117 65.5999 53.772 66.7417L53.8626 66.6206Z",
    fill: "#4A75CB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.089 66.5422C53.089 66.5422 52.5021 66.4711 51.627 66.351C49.3041 66.0314 44.9533 65.363 44.1722 64.7443C42.9452 63.7726 45.8529 59.6454 47.1117 59.0726C48.3705 58.5002 53.0894 66.5422 53.0894 66.5422H53.089Z",
    fill: "#72A9F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2945 61.4026C62.5043 62.4249 53.0024 66.8421 53.0024 66.8421C53.0024 66.8421 53.1754 66.3747 53.4566 65.6428C53.4566 65.6428 53.457 65.6421 53.4576 65.6415C54.4849 62.9681 56.9595 56.7646 57.7729 56.8505C57.8547 56.859 57.9503 56.8882 58.0569 56.9348C59.306 57.4843 62.1017 60.4609 62.2948 61.4023L62.2945 61.4026Z",
    fill: "#72A9F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9766 57.8442C57.3963 58.8523 53.5182 65.5374 53.4575 65.6415C54.4848 62.9681 56.9594 56.7646 57.7728 56.8505C57.7728 56.8505 57.9339 56.8458 58.0568 56.9348C58.205 57.0427 58.2972 57.2874 57.9766 57.8438V57.8442Z",
    fill: "#4A75CB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6284 66.3509H51.6268C49.3039 66.0313 44.953 65.3629 44.172 64.7442C43.8194 63.7508 44.7344 63.67 45.4003 63.6002C46.0656 63.5303 51.6284 66.3509 51.6284 66.3509Z",
    fill: "#4A75CB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3169 66.8585C51.3169 66.8585 51.8494 65.6469 52.8978 65.5795C53.9928 65.5094 54.6146 66.8585 54.6146 66.8585H51.3169Z",
    fill: "#4A75CB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0827 66.8677H42.6724V69.0761H58.0827V66.8677Z",
    fill: "#88B3FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8915 66.8677H58.083V69.0761H63.8915V66.8677Z",
    fill: "#3969B7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8545 66.6829C51.8545 66.6829 48.8361 65.7267 46.7994 66.3589C44.4519 67.0874 44.5909 69.9844 44.5909 69.9844L45.1429 69.7573L45.8884 70.1071C45.8884 70.1071 46.0142 67.0396 47.9283 66.6103C49.5834 66.2391 51.8545 66.6829 51.8545 66.6829Z",
    fill: "#4A75CB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3065 66.8677H49.1826V83.0635H50.3065V66.8677Z",
    fill: "#AFCDFB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6279 50.918L37.1732 52.8652",
    stroke: "#7878F2",
    strokeWidth: 1.4162,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8735 51.6196L35.9263 52.1649",
    stroke: "#7878F2",
    strokeWidth: 1.4162,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9824 65.3772L94.5277 67.3245",
    stroke: "#7878F2",
    strokeWidth: 1.4162,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M95.229 66.0789L93.2817 66.6241",
    stroke: "#7878F2",
    strokeWidth: 1.4162,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0308,
    cy: 43.3142,
    r: 0.494464,
    stroke: "#CAC9E8",
    strokeWidth: 0.958346
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.0781,
    cy: 47.218,
    r: 0.494464,
    stroke: "#CAC9E8",
    strokeWidth: 0.958346
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBonusIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bonus-icon.4b83dd79.svg";
export { ForwardRef as ReactComponent };